import { ChannelType } from 'common/core/constants/ChannelType'
import { api } from 'shared/api'

import { ChatApiSchemas } from './schemas'

export const chatApi = {
  messages: {
    fetch: api.account.createGet({
      url: '/im/loadMessages',
      schemas: ChatApiSchemas.messages.fetch,
    }),
    sendFacebook: api.account.createPost({
      url: '/im/sendMessage',
      schemas: ChatApiSchemas.messages.sendFacebook,
    }),
    createNote: api.account.createPost({
      url: '/im/createNote',
      schemas: ChatApiSchemas.messages.createNote,
    }),
    sendInstagram: api.account.createPost({
      url: '/im/sendInstagramMessage',
      schemas: ChatApiSchemas.messages.sendInstagram,
    }),
    sendTelegram: api.account.createPost({
      url: '/im/sendTelegramMessage',
      schemas: ChatApiSchemas.messages.sendTelegram,
    }),
    sendFlow: api.account.createPost({
      url: '/im/sendFlow',
      schemas: ChatApiSchemas.messages.sendFlow,
    }),
    sendWhatsApp: api.account.createPost({
      url: '/im/sendWhatsAppMessage',
      schemas: ChatApiSchemas.messages.sendWhatsApp,
    }),
    sendSMS: api.account.createPost({
      url: '/im/sendSMS',
      schemas: ChatApiSchemas.messages.sendSMS,
    }),
    sendTiktok: api.account.createPost({
      url: '/im/sendTiktokMessage',
      schemas: ChatApiSchemas.messages.sendTiktok,
    }),
  },
  markThreadAsUnread: api.account.createPost({
    url: '/im/markThreadAsUnread',
    schemas: ChatApiSchemas.markThreadAsUnread,
  }),
  getUserLocation: api.account.createGet({
    url: '/im/getUserLocation',
    schemas: ChatApiSchemas.getUserLocation,
  }),
  setPauseForever: api.account.createPost({
    url: '/im/setAutomationPauseForever',
    schemas: ChatApiSchemas.setAutomationPauseForever,
  }),
  setPause: api.account.createPost({
    url: '/im/setAutomationPause',
    schemas: ChatApiSchemas.setAutomationPause,
  }),
  clearPause: api.account.createPost({
    url: '/im/clearAutomationPause',
    schemas: ChatApiSchemas.clearPause,
  }),
}

export const SendFunction = {
  [ChannelType.FB]: chatApi.messages.sendFacebook,
  [ChannelType.INSTAGRAM]: chatApi.messages.sendInstagram,
  [ChannelType.WHATSAPP]: chatApi.messages.sendWhatsApp,
  [ChannelType.TELEGRAM]: chatApi.messages.sendTelegram,
  [ChannelType.TIKTOK]: chatApi.messages.sendTiktok,
  [ChannelType.SMS]: chatApi.messages.sendSMS,
} as const
